import {postWithId} from "../stores/request.js";

const {MATT_CONTENT_API} = window;

export default class MediaLog {
  static async log(auth, url, action, data) {
    const payload = {url, action, data};
   return postWithId(auth, `${MATT_CONTENT_API}/medialog`, payload);
  }
}